import { useCallback, useState } from "react";
import { useIntl } from "react-intl";

import { Button } from "@/components/Button/Button";
import { ListToggleButton } from "@/components/ListToggleButton/ListToggleButton";
import {
  ToggleButtonGroup,
  type ToggleButtonGroupProps,
} from "@/components/ToggleButtonGroup/ToggleButtonGroup";
import { ReservationType } from "@/features/bookings/types/types";

import { reservationTypesLabels } from "./labels";

type Props = {
  value: ReservationType;
  onValueChange: (value: ReservationType) => void;
};

export const OrdersTypeList = ({ value, onValueChange }: Props) => {
  const intl = useIntl();
  const [currentReservationType, setCurrentReservationType] =
    useState<ReservationType>(value);

  const handleChange = useCallback<
    NonNullable<ToggleButtonGroupProps["onChange"]>
  >((_event, nextValue) => {
    if (typeof nextValue !== "string") {
      return;
    }

    setCurrentReservationType(nextValue as ReservationType);
  }, []);

  return (
    <div className="relative w-full">
      <ToggleButtonGroup
        value={currentReservationType}
        onChange={handleChange}
        orientation="vertical"
        fullWidth
        exclusive
        size="small"
        color="primary"
        aria-label={intl.formatMessage({ id: "bookingTypeOptionsLabel" })}
      >
        {Object.values(ReservationType).map((reservationType) => (
          <ListToggleButton
            key={reservationType}
            value={reservationType}
            selected={currentReservationType === reservationType}
          >
            {intl.formatMessage(reservationTypesLabels[reservationType])}
          </ListToggleButton>
        ))}
      </ToggleButtonGroup>

      <div className="mt-4">
        <Button
          fullWidth
          onClick={() => onValueChange(currentReservationType)}
          variant="contained"
          size="large"
        >
          {intl.formatMessage({ id: "done" })}
        </Button>
      </div>
    </div>
  );
};
